import { useMemo } from 'react'

import type { CustomField } from '@sales-center/common'

import { customValuesToFormModel } from '@user/components/CustomFields'
import type { UpdateRequiredFieldsFormModel } from '@user/features/PendingLeadAutoReview/typings'

/**
 * The Pending Lead form model plus the lead-only follow-up fields, and the keys the reused Add
 * Lead selects read (`leadSourceId`, `targetPests`, `state`).
 */
export type LeadCompanyRequiredFieldsFormValues =
  UpdateRequiredFieldsFormModel & {
    preferredMethodOfContact: string
    preferredTimeOfContact: string[]
    nextActionDate: Date | null
    leadSourceId: string
    targetPests: string[]
    state: string
  }

/** Blank values: the server reports only which fields are missing, not the lead's other values. */
export function useInitialValues(customFields: CustomField[]) {
  return useMemo<LeadCompanyRequiredFieldsFormValues>(
    () => ({
      firstName: '',
      lastName: '',
      company: '',
      phoneNumber: '',
      emailAddress: '',
      branchId: '',
      salesTeamId: null,
      assigneeId: '',
      salesFunnelId: null,
      salesFunnelStageId: null,
      divisionId: '',
      altPhoneNumber: '',
      street1: '',
      street2: '',
      city: '',
      stateAbbreviation: '',
      postalCode: '',
      locationTypeId: '',
      note: '',
      targetPestIds: [],
      campaignId: '',
      sourceId: '',
      referralCode: '',
      referringBillTo: '',
      customFields: customValuesToFormModel(customFields, []),
      preferredMethodOfContact: '',
      preferredTimeOfContact: [],
      nextActionDate: null,
      leadSourceId: '',
      targetPests: [],
      state: '',
    }),
    [customFields],
  )
}
